module.exports = __webpack_public_path__ + "img/cq.5075e777.png";